import React from 'react'
import LxHeader from '@/components/LxHeader/One'
// import { Link } from 'react-router-dom'
import styles from './index.module.scss'
import {getDynamicApi} from '@/api'
import {Pagination, ConfigProvider} from "antd"
import zhCN from 'antd/es/locale/zh_CN';
const banner = require("./img/banner.png")

class RecriutmentNews extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showList: [],
            currentShowList: {},
            currentPage: 1,
            total: 1,
        }
    }

    componentDidMount() {
        getDynamicApi({dynamicKey: 0, pageSize: 9999}).then(res => {
            let showList = (res && res.data && res.data.dynamicDetail) || []
            // 分页
            let length = showList.length
            let currentShowList = {}
            let total = 1
            if (length <= 10) {
                currentShowList[1] = showList
            } else {
                total = length % 10 > 0 ? Math.floor(length / 10) + 1 : Math.floor(length / 10)
                console.log(total)
                for (let i = 1; i <= total; i++) {
                    currentShowList[i] = showList.slice(10 * (i - 1), 10 * i)
                }
            }
            console.log(currentShowList)
            this.setState({
                total: total,
                showList: showList,
                currentShowList: currentShowList
            })
        })
    }

    goDetail = (showList, index) => {
        this.props.history.push(`/recruitmentNewsDetail?index=${index}`)
    }

    render() {
        const {showList, currentShowList, currentPage, total} = this.state;
        let list = currentShowList[currentPage]
        return (
            <>
                <LxHeader></LxHeader>
                <div className={styles.newsWrap}>
                    <img className="newsBanner" src={banner} alt="banner"/>
                    <div className="newContentWrap">
                        <div className="wrapTitle">招聘公示</div>
                        {list && list.length ?
                            list.map((item, index) => {
                                return <div className="wrapItem" key={index} onClick={() => {
                                    this.goDetail(showList, index)
                                }}>
                                    <div className="itemLeft">{item.title}</div>
                                    <div className="itemRight">发布时间 {item.times}</div>
                                </div>
                            }) : null}
                    </div>
                    {total > 1 ?
                        <div className="Pagination-wrap">
                            <ConfigProvider locale={zhCN}>
                                <Pagination
                                    size="small"
                                    current={currentPage}
                                    total={showList.length}
                                    showQuickJumper
                                    showTotal={t => `共${total}页`}
                                    onChange={(page, pageSize) => {
                                        this.setState({
                                            currentPage: page
                                        })
                                    }}
                                />
                            </ConfigProvider>
                        </div> : null}
                </div>
            </>
        )
    }
}

export default RecriutmentNews;
